/**
 * Shared mapper from `TraceListRow` (the `/api/traces/list` row shape) onto
 * the superset `TraceTableRow` that `<TraceTable>` consumes.
 *
 * Phase 8 Plan 04 — factored out of the inline `toTableRow` originally
 * defined at `TraceDrillDownModal.tsx:74`. Three call sites now share it:
 *
 *   - `TraceDrillDownModal`               (Overview / Quality / Operations charts)
 *   - `UserDrilldownPage` (Activity tab)  (Phase 8 migration)
 *   - `UserDetail.tsx` (Feedback tab)     (Phase 8 HD-1 migration)
 *
 * `TimeSavedBreakdownModal` keeps its own mapper because the
 * `TimeSavedBreakdownItem` shape differs (`username`/`totalCost` vs
 * `userId`/`cost`); migrating it is out of scope for this plan.
 */
import type { TraceListRow } from '@/services/api-types';
import type { TraceTableRow } from '@/components/TraceTable';

export function tracelistRowToTableRow(row: TraceListRow): TraceTableRow {
  return {
    traceId: row.traceId,
    timestamp: row.timestamp,
    userId: row.userId,
    realName: row.realName,
    name: row.name,
    complexity: row.complexity,
    rating: row.rating,
    latencyMs: row.latencyMs,
    cost: row.cost,
    input: row.input,
    output: row.output,
    error: row.error,
    textFeedback: row.textFeedback,
    safetyRefused: row.safetyRefused,
    hasError: row.hasError,
    isRm: row.isRm,
  };
}
